export default function PlaystationIcon(props) {
  return (
    <svg
      className={props.className}
      viewBox="0 0 29 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_705_1752)">
        <mask
          id="mask0_705_1752"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="29"
          height="23"
        >
          <path
            d="M28.1091 0.797974H0.309052V22.248H28.1091V0.797974Z"
            fill={props.color ? props.color : 'white'}
          />
        </mask>
        <g mask="url(#mask0_705_1752)">
          <path
            d="M4.86833 18.1379C5.76833 18.3479 6.70833 18.2979 7.57833 17.9979L9.81833 17.1879V19.5379L9.37833 19.6079C7.03833 19.9879 4.64833 19.7979 2.39833 19.0479C0.208334 18.4279 -0.161666 17.1479 0.838334 16.3979C1.61833 15.8879 2.45833 15.4879 3.33833 15.1979L9.82833 12.8979V15.5279L5.15833 17.1979C4.32833 17.4979 4.20833 17.9179 4.87833 18.1279"
            fill={props.color ? props.color : 'white'}
          />
          <path
            d="M27.8583 17.218C27.3283 17.738 26.6883 18.138 25.9883 18.388L16.0883 21.948V19.328L23.3683 16.728C24.1983 16.428 24.3283 16.018 23.6483 15.798C22.7483 15.588 21.8083 15.638 20.9383 15.938L16.0883 17.648V14.928L16.3683 14.838C17.4683 14.488 18.5983 14.248 19.7483 14.128C21.8683 13.908 24.0183 14.168 26.0283 14.878C28.1683 15.548 28.4083 16.548 27.8583 17.228"
            fill={props.color ? props.color : 'white'}
          />
          <path
            d="M17.0277 12.748V6.04797C17.0277 5.26797 16.8877 4.53797 16.1477 4.33797C15.5777 4.15797 15.2277 4.67797 15.2277 5.46797V22.248L10.6977 20.808V0.797974C12.8077 1.24797 14.8977 1.81797 16.9377 2.50797C20.7677 3.82797 22.0677 5.46797 22.0677 9.15797C22.0677 12.848 19.8477 14.118 17.0277 12.758"
            fill={props.color ? props.color : 'white'}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_705_1752">
          <rect
            width="27.8"
            height="21.45"
            fill={props.color ? props.color : 'white'}
            transform="translate(0.309052 0.797974)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
